import PropTypes from 'prop-types';

import { CitiesProvider } from '../../context/CitiesContext';

import Hero from './Hero/Hero';
import FindPlace from './FindPlace';
import RelevantLinkSection from './RelevantLinkSection';
import CityListContainer from './CityListContainer/CityListContainer';

const GenericErrorContent = ({ title = 'error_page.client_error.title' }) => {
  return (
    <CitiesProvider>
      <Hero title={title} />
      <FindPlace />
      <RelevantLinkSection />
      <CityListContainer />
    </CitiesProvider>
  );
};

GenericErrorContent.propTypes = {
  title: PropTypes.string
};

export default GenericErrorContent;
